const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
export function squareCropRect(width, height, x = 0.5, y = 0.5, zoom = 1) {
  if (!(width > 0 && height > 0)) throw Error('Invalid image dimensions');
  const size = Math.min(width, height) / clamp(zoom, 1, 3);
  return { x: (width - size) * clamp(x, 0, 1), y: (height - size) * clamp(y, 0, 1), size };
}
export async function exportSquareCover(image, position) {
  const { x, y, size } = squareCropRect(image.naturalWidth, image.naturalHeight, ...position);
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = Math.min(1600, Math.max(1, Math.round(size)));
  const context = canvas.getContext('2d');
  if (!context) throw Error('Image editing unavailable');
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.drawImage(image, x, y, size, size, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.82));
  if (!blob || blob.size > 5 * 1024 * 1024) throw Error('Image export failed');
  return new File([blob], 'playlist-cover.jpg', { type: 'image/jpeg' });
}
